<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Existing Customer Found">
            <b-container fluid>
                <p>Customer with matching e-mail currently exists.</p>
                <p>Would you like to reset your password?</p>
            </b-container>

            <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm" variant="success" @click="resetPasswordRedirect">
                    Reset Password
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [],

		data() {
			return {
				modalName: 'modal-registration-customer-sign-up-duplicate-found'
			}
		},

		methods: {
            resetPasswordRedirect() {
                window.location.href = env.COMPANY_URL + '/forgot-password/'
            }
		}
	}
</script>

<style lang="scss">
    #modal-registration-customer-sign-up-duplicate-found {

    }
</style>
